<template>
    <div class="comments__content">
        <div class="wrapper comments__desc">
            <b>W przypadku obecnych przerzutów do płuc</b>
            <br/>konieczna konsultacja torakochirurgiczna z oceną resekcyjności zmian
            <br/>i planem postępowania.
            <div class="form__error" v-if="error"> {{ error }}</div>
            <div class="form__row form__row--center">
                <a v-if="!submitBtnClass.includes('spinner')" class="btn btn--blue" @click="$emit('back', 4)">Powrót</a>
                <a :class="submitBtnClass" @click="submitForm">Wyślij</a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

export default {
    name: "Comments",
    data() {
        return {
            submitBtnClass: "btn",
            error: ''
        };
    },
    computed: mapGetters({
        data: "getReportData",
        token: "getToken"
    }),
    methods: {
        submitForm() {
            const {patientData, medicalData, findings, attachments} = this.data;

            if (attachments.folderId === "") {
                this.error = "Przesyłanie plików nie zostało zakończone lub wystąpił błąd"
                this.submitBtnClass = "btn btn--disabled";
                return;
            }

            this.error = "";
            this.submitBtnClass = "btn spinner spinner--running";

            axios({
                method: "post",
                url: `${process.env.VUE_APP_API_URL}/medical-case`,
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${this.token}`
                },
                data: {
                    patientData: {
                        ...patientData,
                        age: parseInt(patientData.age),
                        weight: parseFloat(patientData.weight),
                        height: parseInt(patientData.height),
                    },
                    medicalData: {
                        ...medicalData,
                        adjuvantTreatment: {
                            ... medicalData.adjuvantTreatment,
                            chemotherapyAmount: parseInt(medicalData.adjuvantTreatment.chemotherapyAmount),
                            endDateOfTheLastCourse: medicalData.adjuvantTreatment.endDateOfTheLastCourse !== '' ? medicalData.adjuvantTreatment.endDateOfTheLastCourse : null,
                        }
                    },
                    findings,
                    attachments: {
                        ...attachments,
                        folderFilesCount: parseInt(attachments.folderFilesCount),
                    },
                },
            })
                .then((response) => {
                    this.submitBtnClass = "btn spinner spinner--complete";

                    this.$store.dispatch('refreshUserToken')
                    this.$emit('updateMedCaseId', response.data.id);
                    setTimeout(() => this.$emit("next", 6), 1000);
                })
                .catch((err) => {
                    this.error = err.response.data.message;
                    this.submitBtnClass = "btn";
                });
        }
    }
};
</script>

<style lang="scss">
.comments {
    &__content {
        text-align: center;
        margin: 45px 0;
    }
}

.btn {
    margin: 20px 20px 0 0;
}
</style>
